<template>
  <div class="wrapper">
    <dashboardNav/>
    <!-- Page Content  -->
    <div id="content">
      <div class="container"> <!-- Alerts --> </div>

      <loader :isLoading="requestInProgress"/>
      <!-- Page Content  -->
      <div class="main container" v-if="!requestInProgress">
        <div v-if="isToEdit">
          <PassForm
            :cancelEdit="cancelEdit"
            :validateBeforeSubmit="validateBeforeSubmit"
            :form="form"
            :error="error"
            :action="action"
            :agreementCategories="agreementCategories"
            :userDetailCategories="userDetailCategories"
            :error_message="error_message"
            :updateErrorState="updateErrorState"
            :addFormQuestion="addFormQuestion"
            :deleteFormQuestion="deleteFormQuestion"
            submitButtonName="Edit Pass" />
        </div>
        <div v-else>
          <section id="section-name">
            <a href="/dashboard/passes">
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
              &nbsp; Back to Dashboard
            </a>

            <pass-detail-header
              :routeUrl="routeUrl"
              :isToggleActionList="isToggleActionList"
              :passDetail="passDetail"
              :onClickDelete="onClickDelete"
              :onClickDeactivate="onClickDeactivate"
              :onClickEdit="onClickEdit"
              :onClickShare="onClickShare"
              :onClickToggleAction="onClickToggleAction" />

            <br/>
          </section>

          <div class="line"></div>

          <!-- BUSINESS TABS -->
          <div>
            <BaseTab
              :isOrganizer="isOrganizer"
              :passDetail="passDetail"
              :acceptedList="acceptedList"
              :invitesList="invitesList"
              :requestsList="requestsList"
              :scansList="scansList"
              :agreementCategories="agreementCategories"
              :userDetailCategories="userDetailCategories"
              :hasAccepted="hasAccepted"
              :hasRequests="hasRequests"
              :hasScans="hasScans"
              :onClickDeactivate="onClickDeactivate"
              :onClickEdit="onClickEdit"/>
          </div>
        </div>
      </div>
      <p v-if="errMessage">{{ errMessage }}</p>
    </div>
  </div>
</template>

<script>
import DashboardNav from '@/components/common/DashboardNav'
import Loader from '@/components/common/Loader'
import Modal from '@/components/common/Modal'

import PassForm from '@/components/passes/PassForm'
import PassDetailHeader from '@/components/passes/PassDetailHeader'
import BaseTab from '@/components/tabview/BaseTab'

import PassInvite from '@/containers/passes/PassInvite'

import { APIService } from '@/api/APIService'
import { AuthService } from '@/api/AuthService'
import { CommonHelper } from '@/api/helper/CommonHelper'
import { DateTimeHelper } from '@/api/helper/DateTimeHelper'
import { TIME_PICKER_FORMAT } from '@/api/constants/Common'
import { USER_DETAIL_CATEGORIES } from '@/api/constants/Business'

const api = new APIService()
const auth = new AuthService()
const common = new CommonHelper()
const date = new DateTimeHelper()

export default {
  components: {
    'pass-detail-header': PassDetailHeader,
    BaseTab,
    dashboardNav: DashboardNav,
    Loader,
    Modal,
    PassForm,
    PassInvite
  },
  data() {
    return {
      form: {
        pass_name: '',
        type_of_pass: '',
        company_logo: '',
        company_name: '',
        company_email: '',
        visit_date: '',
        valid_date: '',
        visit_time: TIME_PICKER_FORMAT,
        valid_time: TIME_PICKER_FORMAT,
        disposal_date: '',
        floor_number: '',
        reason_for_visit: '',
        reason_for_collecting: '',
        contact_person: '',
        contact_email: '',
        pass_intro: '',
        pass_access_questions: [
          { type: 'text', question: '' }
        ],
        included_pass_details: ['Full Name'],
        visiting_agreements: [],
        verify_identity: false,
        request_access: false
      },
      isOrganizer: auth.getIsEventOrganizer(),
      passDetail: {},
      formCopy: {},
      routeUrl: '',
      action: 'edit',
      userId: auth.getUserId(),
      companyId: auth.getCompanyId(),
      loggedInUserId: auth.getUserId(),
      accountType: auth.getAccountType(),
      passId: this.$route.params.id,
      isToEdit: false,
      isForm: false,
      isToggleActionList: false,
      userDetailCategories: USER_DETAIL_CATEGORIES,
      agreementCategories: [], // AGREEMENTS_CATEGORIES,
      error: {
        visit_date: '',
        visit_time: '',
        valid_date: '',
        valid_time: '',
        disposal_date: '',
        included_pass_details: '',
        visiting_agreements: '',
        pass_intro: '',
        request_question: '',
        message: ''
      },
      errMessage: '',
      error_message: '',
      epochVisitDateTime: '',
      epochValidDateTime: '',
      epochDisposalDate: '',
      invitesList: [],
      scansList: [],
      requestsList: [],
      acceptedList: [],
      hasScans: false,
      hasRequests: false,
      hasAccepted: false,
      haveError: false,
      haveVuelidateError: false,
      requestInProgress: false
    }
  },
  mounted() {
    if(this.accountType === 'business') {
      this.getUserDetails()
      this.getPassDetail()
      this.getBusinessAgreements()
    }
  },
  updated() {
    this.routeUrl = `${window.location.origin}/invite/passes/${this.form.shareable_link_id}`
  },
  methods: {
    async getUserDetails() {
      try {
        const userDetail = await api.getUserDetails(this.userId)
        const companyDetails = userDetail.profile_details.company_details
        this.form.company_name = companyDetails.company_name
        this.form.company_logo = companyDetails.company_logo
        this.form.company_email = userDetail.email_address
        if(!this.isOrganizer) {
          this.form.building_name = companyDetails.building_name
          this.form.building_address = companyDetails.building_address
        }
      } catch(e) {
        this.redirectToLogin()
      }
    },
    async getPassDetail() {
      try {
        this.requestInProgress = true
        const passDetail = await api.getPassInviteScans(this.passId)
        this.requestInProgress = false
        this.form = passDetail
        if(this.form.pass_access_questions === undefined) {
          this.form.pass_access_questions = [
            { type: 'text', question: '' }
          ]
        }

        this.formCopy = {...passDetail}
        this.passDetail = {...passDetail}
        this.invitesList = passDetail.invites_data
        if(this.invitesList.length !== 0) {
          this.invitesList.sort((a, b) => { return a.status.localeCompare(b.status) })
        }
        const scansData = passDetail.scans_data
        const requestsData = passDetail.requests_data
        this.hasScans = scansData.length !== 0
        if(this.hasScans) {
          const sortByDate = scansData.sort((a, b) => a.date_created - b.date_created)
          const scansGroupByName = common.groupBy(sortByDate, (s) => s.individual_details.full_name)
          const groupedScans = Object.keys(scansGroupByName).map(x => {
            const checkinDates = scansGroupByName[x]
              .filter(i => i.action === 'CHECK-IN')
              .map(y => y.date_created )

            const checkoutDates = scansGroupByName[x]
              .filter(i => i.action === 'CHECK-OUT')
              .map(y =>  y.date_created )

            return {
              individual_name: x,
              check_in_dates: checkinDates,
              check_out_dates: checkoutDates
            }
          })
          this.scansList = groupedScans
        }
        else { this.scansList = [] }
        this.hasRequests = requestsData.length !== 0
        this.requestsList = requestsData
        this.constructAcceptedList()
      } catch(e) {
        this.logout()
      }
    },
    async getBusinessAgreements() {
      try {
        this.requestInProgress = true
        const agreementsData = await api.getBusinessAgreementsByUserID(this.companyId)
        this.agreementCategories = agreementsData.map(d => {
          return {
            id: d.id,
            name: d.agreement_name,
            other_name: d.other_agreement_name,
            date_created: d.date_created
          }
        }).sort((a, b) => { return a.date_created - b.date_created })
        this.requestInProgress = false
      } catch(e) {
        this.logout()
      }
    },
    async onClickDelete() {
      this.requestInProgress = true
      await api.deletePass(this.passId)
      this.requestInProgress = false
      this.$router.push('/dashboard/passes')
    },
    async onClickDeactivate() {
      const params = { status: 'Deactivated' }
      this.requestInProgress = true
      await api.updatePassStatus(this.passId, params)
      this.requestInProgress = false
      // do email to invites here after deactivating pass
      this.$router.push('/dashboard/passes')
    },
    async updateFields() {
      let fields = { ...this.form, user_id: this.userId }
      fields = common.deleteByObjKey(fields, 'visit_time')
      fields = common.deleteByObjKey(fields,'valid_time')
      this.requestInProgress = true

      fields.disposal_period = this.epochDisposalDate
      fields.valid_from = this.epochVisitDateTime
      fields.valid_until = this.epochValidDateTime
      fields.visiting_date = date.convertDate(this.form.visiting_date)
      fields.visiting_time = date.convertTime(this.form.visit_time)
      fields.validity_date = date.convertDate(this.form.validity_date)
      fields.validity_time = date.convertTime(this.form.valid_time)
      fields.pass_status = 'Pending'
      fields.pass_intro = this.form.request_access ? this.form.pass_intro : 'none'
      fields.pass_access_questions = this.form.pass_access_questions
      fields.contact_email = this.form.contact_email.toLowerCase()
      fields.building_name = this.form.building_name
      fields.building_address = this.form.building_address

      try {
        const passDetail = await api.updatePass(this.passId, fields)
        this.requestInProgress = false
        if(passDetail.statusCode === 200) {
          this.isToEdit = false
          this.getPassDetail()
        } else {
          this.error_message = passDetail.message
        }
      } catch(err) {
        this.requestInProgress = false
        this.error_message= err
      }
    },
    // non-async functions
    addFormQuestion() {
      if(this.form.pass_access_questions.length < 5) {
        this.form.pass_access_questions.push({ type: 'text', question: '' })
      }
    },
    deleteFormQuestion(i) {
      if(this.form.pass_access_questions.length > 1) {
        this.form.pass_access_questions.splice(i, 1)
      }
    },
    updateErrorState(value) { this.haveVuelidateError = value },
    onClickShare() {
      this.$router.push({ name: 'PassInvite', params: { id: this.passId } })
    },
    onClickEdit() {
      // enable edit fields
      this.setTimeFormat()
      this.isToEdit = true
      this.isForm = true
      this.isToggleActionList = false
    },
    cancelEdit() {
      this.isToEdit = false
      this.form = {...this.formCopy}
    },
    onClickToggleAction() {
      this.isToggleActionList = !this.isToggleActionList
    },
    setTimeFormat() {
      this.form.visit_time = date.convertTimeToTimePickerFormat(this.form.visiting_time)
      this.form.valid_time = date.convertTimeToTimePickerFormat(this.form.validity_time)
    },
    convertEpochTime(epoch) { return date.convertUnixToDateTimeFormat(epoch) },
    validateBeforeSubmit() {
      this.error = {}
      this.errMessage = ''
      this.error_message = ''
      this.haveError = false

      if (this.form.type_of_pass.length === 0) {
        this.error.type_of_pass = 'Please select type of pass'
        this.haveError = true
      }

      // TODO: check if vistingTime is past 6pm???
      const visitDate = this.form.visiting_date
      const validDate = this.form.validity_date

      const visitTime = this.form.visit_time
      const validTime = this.form.valid_time

      this.epochVisitDateTime = date.convertDateTimeToUnix(visitDate, visitTime)
      this.epochValidDateTime = date.convertDateTimeToUnix(validDate, validTime)

      const disposalDate = this.form.disposal_date
      const disposalByNum = disposalDate.split(' ')[0]
      const disposalByPeriod = disposalDate.split(' ')[1]
      this.epochDisposalDate = date.addDaysToDate(validDate, disposalByNum, disposalByPeriod)

      const formVisitTime = date.convertTimeObject(visitTime)
      const oldVisitDate = this.formCopy.visiting_date
      const oldVisitTime = this.formCopy.visiting_time

      // display if epochVisitDateTime is not today or future date
      if(visitDate !== oldVisitDate || formVisitTime !== oldVisitTime) {
        if (!date.compareEpochDateToday(this.epochVisitDateTime)) {
          this.error.visit_date =
            'Please change visiting date field to today or future date'
          this.haveError = true
        }
      }

      // display if visitDate and validDate is more than 3 months
      if (!date.checkIfDateIsPastMonths(visitDate) || !date.checkIfDateIsPastMonths(validDate)) {
        this.error.visit_date =
          'Please change visiting date is more than 3 months'
        this.haveError = true
      }
      // display if validDateTime is overlapping epochVisitDateTime
      if (!date.compareTwoEpochDate(this.epochVisitDateTime, this.epochValidDateTime)) {
        this.error.valid_date =
          'Please change pass validity date coz it\'s overlapping the visiting time'
        this.haveError = true
      }

      if (this.form.included_pass_details.length === 0) {
        this.error.included_pass_details =
          'Please choose details that you want to include in this pass'
        this.haveError = true
      }
      if (this.form.visiting_agreements.length === 0) {
        this.error.visiting_agreements =
          'Please choose visiting agreements that you want to include in this pass'
        this.haveError = true
      }

      if (this.form.request_access && this.form.pass_intro === '') {
        this.error.pass_intro = 'Please fill-in pass intro'
        this.haveError = true
      }

      if(this.form.pass_access_questions.length === 1) {
        if(this.form.pass_access_questions[0].question === '')
          this.form.pass_access_questions[0].question = 'none'
      }

      if (this.haveError || this.haveVuelidateError) {
        this.error_message = 'Please check the form errors'
      }
      else this.updateFields()
    },
    constructAcceptedList() {
      const acceptedInvite = this.invitesList.filter((d) => { return d.status === 'Accepted' })
      const acceptedRequest = this.requestsList.filter((d) => { return d.request_status === 'Accepted' })

      this.acceptedList = [...acceptedInvite, ...acceptedRequest]
      this.hasAccepted = this.acceptedList.length !== 0
    },
    logout() {
      auth.logout()
      this.$router.push('/login')
    }
  }
}
</script>

<style>
small{
  color:#547181;
}

.bold-font {
  font-weight: bold;
}

.nav.nav-tabs {
  border: 1px solid #dee2e6;
  border-bottom: none;
}

.nav.nav-tabs .active {
  background: #FAFAFA;
  border-right: 1px solid #FAFAFA;
  border-left: 1px solid #FAFAFA;
}

.nav-tabs .nav-item {

}

.nav-tabs .nav-link.active {
  color: #00386a;
  font-weight: bold;
}

.nav-tabs .nav-link {
  border-top-left-radius: 0rem;
  border-top-right-radius: 0rem;
  border: none;
  color: #0091f4;
  font-weight: bold;
}

.nav-item {
  margin-left: 0px;
  font-size: 12px;
}

.nav-link {
  padding: 12px 30px;
}

.modal-content {
  padding: 0px;
}

.modal-header {
  padding: 10px;
  width: 100%;
  border: none;
}

.modal-header-content {
  width: 100%;
}

.btn-x {
  color: #007bff;
  border: 1px solid #007bff;
  border-radius:50%;
  -moz-border-radius:50%;
  -webkit-border-radius:50%;
  width: 25px;
  height: 25px;
  padding: 0px;
}

.modal-dialog-scrollable {
  width: 40%;
  height: 80%;
  margin: 100px auto;
}

.modal-title {
  margin-bottom: 0px;
}

.modal-title p {
  margin-bottom: 0px;
  font-weight: bold;
  font-size: 12px;
  color: #6c757d;
}

.modal-title h6 {
  padding-top: 10px;
  font-weight: bold;
  margin-bottom: 0px;
}

.modal-body {
  padding: 0px;
  background-color: #fff;
  border: none;
}

.modal-footer {
  border: none;
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/containers/passes/PassDetailView.vue